import {ReduxState} from '../../common/types/state';

export function selectError(state: ReduxState) {
  return state.error.message;
}
